import { membersBaseURL, clearObject } from "@/functions/helpers";

const baseURL = membersBaseURL();

const _post = (url, params, config = {}) =>
  window.axios.post(url, params, { baseURL, ...config });
const _put = (url, params) => window.axios.put(url, params, { baseURL });
const _delete = url => window.axios.delete(url, { baseURL });
const _get = url => window.axios.get(url, { baseURL });

export default {
  getAll(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();

      return _get(`/quizzes`)
        .then(({ data: { results, count, next, previous } }) => {
          context.commit("setQuizzes", results);
          context.commit("setPagination", { count, next, previous });
          resolve({ data: { results, count, next, previous } });
        })
        .catch(reject);
    });
  },
  getQuizz(context, uuid) {
    return new Promise((resolve, reject) => {
      return _get(`/quizzes/${uuid}`)
        .then(({ data }) => resolve(data))
        .catch(reject);
    });
  },
  post(context, params) {
    return new Promise((resolve, reject) => {
      _post("/quizzes", params)
        .then(resolve)
        .catch(reject);
    });
  },
  put(context, params) {
    return new Promise((resolve, reject) => {
      _put(`/quizzes/${params.code}`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  delete(context, code) {
    return new Promise((resolve, reject) => {
      _delete(`/quizzes/${code}`)
        .then(resolve)
        .catch(reject);
    });
  },
  getQuizzFinal(context, product_id) {
    return new Promise((resolve, reject) => {
      return _get(`/quizzes/final/${product_id}`)
        .then(({ data }) => resolve(data))
        .catch(reject);
    });
  },
  postFinal(context, params) {
    return new Promise((resolve, reject) => {
      _put(`/quizzes/final/${params.product_id}`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  putFinal(context, params) {
    return new Promise((resolve, reject) => {
      _put(`/quizzes/final/${params.product_id}`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  deleteFinal(context, product_id) {
    return new Promise((resolve, reject) => {
      _delete(`/quizzes/final/${product_id}`)
        .then(resolve)
        .catch(reject);
    });
  }
};
